import { render } from "./CoffeeCreator.vue?vue&type=template&id=34598b41&scoped=true"
import script from "./CoffeeCreator.vue?vue&type=script&lang=js"
export * from "./CoffeeCreator.vue?vue&type=script&lang=js"

import "./CoffeeCreator.vue?vue&type=style&index=0&id=34598b41&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34598b41"

export default script